import React, { useState } from "react";
import { ImCross } from "react-icons/im";

// Simplified rebuild of the legacy icon-grid DamagePartPicker
// (Main Folder/Admin/admin_frontend/src/Components/DamagePartPicker.js) -
// same data contract ({partName, damageLevel}), same part vocabulary, but a
// plain grouped dropdown instead of an 8-icon grid + sub-option chip picker.
// Kept deliberately simple for Phase A's scope; ports cleanly later if the
// icon-grid version is ever wanted back.

const PART_GROUPS = [
    { label: "Wheel", options: ["Left Front Wheel", "Left Back Wheel", "Right Front Wheel", "Right Back Wheel"] },
    { label: "Door", options: ["Left Front Door", "Left Back Door", "Right Front Door", "Right Back Door"] },
    { label: "Windshield", options: ["WindShield"] },
    { label: "Music Player", options: ["Music Player"] },
    { label: "Seats", options: ["Driver", "Co-Driver", "Middle Seat", "Back Seats"] },
    { label: "Fender", options: ["Left Front Fender", "Left Back Fender", "Right Front Fender", "Right Back Fender"] },
    { label: "Bumper", options: ["Left Front Bumper", "Left Back Bumper", "Right Front Bumper", "Right Back Bumper"] },
    { label: "Rear Glass", options: ["Rear Glass"] },
];

// The stored value stays "WindShield" (old bookings and the server check use it); only the text people read is "Windshield".
const PART_LABELS = { WindShield: "Windshield" };

export const DAMAGE_LEVELS = ["Minor", "Major", "Medium"];

// Props: damages / setDamages - the parent's running list of
// { partName, damageLevel }. disabled optionally disables the Add control
// while a submit is in flight.
const DamagePartPicker = ({ damages = [], setDamages, disabled = false }) => {
    const [partName, setPartName] = useState("");
    const [damageLevel, setDamageLevel] = useState("");

    const addDamage = () => {
        if (!partName || !damageLevel) return;
        setDamages((prev) => [...(prev || []).filter((d) => d.partName !== partName), { partName, damageLevel }]);
        setPartName("");
        setDamageLevel("");
    };

    const removeDamage = (name) => setDamages((prev) => (prev || []).filter((d) => d.partName !== name));

    return (
        <div>
            <div className="row g-2 align-items-end">
                <div className="col-5">
                    <label className="form-label small">Part</label>
                    <select className="form-select form-select-sm" value={partName} onChange={(e) => setPartName(e.target.value)} disabled={disabled}>
                        <option value="">Select part</option>
                        {PART_GROUPS.map((group) => (
                            <optgroup key={group.label} label={group.label}>
                                {group.options.map((opt) => (
                                    <option key={opt} value={opt}>{PART_LABELS[opt] || opt}</option>
                                ))}
                            </optgroup>
                        ))}
                    </select>
                </div>
                <div className="col-4">
                    <label className="form-label small">Damage level</label>
                    <select className="form-select form-select-sm" value={damageLevel} onChange={(e) => setDamageLevel(e.target.value)} disabled={disabled}>
                        <option value="">Select level</option>
                        {DAMAGE_LEVELS.map((level) => (
                            <option key={level} value={level}>{level}</option>
                        ))}
                    </select>
                </div>
                <div className="col-3">
                    <button type="button" className="btn btn-sm btn-outline-primary w-100" onClick={addDamage} disabled={disabled || !partName || !damageLevel}>
                        Add
                    </button>
                </div>
            </div>

            {!!damages?.length && (
                <div className="d-flex flex-wrap gap-2 mt-3">
                    {damages.map((d) => (
                        <span key={d.partName} className="badge text-bg-light border d-inline-flex align-items-center gap-2">
                            {PART_LABELS[d.partName] || d.partName} · {d.damageLevel}
                            <button
                                type="button"
                                className="btn btn-sm btn-link text-danger p-0"
                                onClick={() => removeDamage(d.partName)}
                                disabled={disabled}
                            >
                                <ImCross size={9} />
                            </button>
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DamagePartPicker;
